import React from "react"

import Button from "@mui/material/Button"

import illustration_Error from "../assets/images/ErrorBoundary.svg"
import image from "../assets/images/logo_integration.png"
import CommonUtils from "./Common"
import i18n from "./i18n"
// Same reason as TableWrapper: getResource() would throw on a null language,
// and throwing here would replace the error screen with a blank page.
const currentLang: string = CommonUtils.GetLanguage()
i18n.loadNamespaces("common")
export default class ErrorBoundary extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {hasError: false, errorMessage: {}}
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true}
    }

    componentDidCatch(error: any, errorInfo: any) {
        // You can also log the error to an error reporting service
        this.setState({errorMessage: {Erreur: error, Info: errorInfo}})
        console.log({ERROR_CATCH: error, ERROR_INFO: errorInfo})
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="containerError">
                    <div className="summaryHeaderError"></div>
                    <img src={image} alt="logo_docoon" className="imgLogoMessageReceiver" />
                    <div className="bodyMessageReceiver">
                        <img src={illustration_Error} alt="" className="illuMessage" />
                        <div className="textMessageBox">
                            <span className="titleMessageBoxError">
                                {i18n.getResource(currentLang, "common", "ErrorMsg")}
                            </span>
                        </div>
                        <div className="confirmBoxBtns">
                            <Button
                                className="BtnsConfirmBox validConfirmBtnError"
                                onClick={() => (window.location.href = "/")}
                            >
                                {i18n.getResource(currentLang, "common", "ErrorBtnTxt")}
                            </Button>
                        </div>
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}
